import React, { useEffect, useState } from 'react'
import { NavLink } from '../../../lib/Navigation';
import URI from 'urijs';
import { Link } from 'react-router-dom';
import Manager from '../Manager';
import SvgPath from './SvgPath';
import "./css/css.css"

export default function HomeBanner(props) {

  const banner = props.banner

  const bannersDiv = ()=>{
    return <div style={{ position: "relative",overflow: "hidden" ,borderRadius: "13px",paddingBottom: (banner.show_game_info ? "20px" : '0')}}>
        <img className = "banner-img" src={banner.img} alt="" />
        {banner.show_game_info && <div style={{ position: "absolute", bottom: 0, left: 0, width: "100%" }}>
          <SvgPath banner={banner}/>
        </div>}
      </div>
  }
  
  return (
    <div className='index-home-banner' key={banner.id}>
      {banner.type === 'insideUrl' || banner.type === 'externalUrl' || banner.type == 'news' ?
        <NavLink user={banner.login} to={(() => {
          if (localStorage.getItem('username')){
            let url = URI(banner.val)
              .addQuery('username', localStorage.getItem('username'))
              .addQuery('token', localStorage.getItem('token'))
              .addQuery('mb', localStorage.getItem('mb'))
              .addQuery('location_url', window.location.origin)
              .addQuery('origin', 'react')
              .toString();
            return url;
          }else{
            let url = URI(banner.val)
              .addQuery('mb', localStorage.getItem('mb'))
              .addQuery('location_url', window.location.origin)
              .addQuery('origin', 'react')
              .toString();
            return url;
          }
        })()}
        onClick={()=>{
          Manager.push({ event_id:banner.event_id })
        }}
        iframe = {{title: banner.title}}
        >
          {bannersDiv()}

        </NavLink>
      : banner.type === 'enterpriseWechat' ?
      <div
        onClick={()=>{
          Manager.push({ event_id:banner.event_id })
          window.location.href = banner.val
        }}
      >
        {bannersDiv()}
      </div>
      :
      <Link
        to={(() => {
          if (banner.type === 'game') {
            return '/game?id=' + banner.val + '&download_source_id=' + banner.download_source_id;
          }
          if (banner.type === 'special') {
            return '/game/project?id=' + banner.val;
          }
          if(banner.type == 'vouchandgift') {
            return '/giftproject'
          }
          if(banner.type == 'signgift') {
            return '/signgift'
          }
          if(banner.type == 'goodgameassist') {
            return '/goodgameassist' + '?download_source_id=' + banner.download_source_id
          }
        })()}
        onClick={()=>{
          Manager.push({ event_id:banner.event_id })
        }}
      >
        {bannersDiv()}
      </Link>}
    </div>
  )
}
